import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PropType, computed } from 'vue'
import ImagePanelUI from '@/components/top/panels/ImagePanel/ImagePanelUI.vue'
import { DefinitionInfoTopGraphicalMapPanelImage } from '@/models/initData/DefinitionInfo'


export default /*#__PURE__*/_defineComponent({
  props: {
  cell: {
    type: Object as PropType<DefinitionInfoTopGraphicalMapPanelImage>,
    required: true,
  },
  tb: {
    type: String,
    required: false,
  },
  lr: {
    type: String,
    required: false,
  },
},
  setup(__props) {

const props = __props


const url = computed(() => {
  return props.cell.args.path
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ImagePanelUI, {
    url: _unref(url),
    tb: __props.tb,
    lr: __props.lr
  }, null, 8, ["url", "tb", "lr"]))
}
}

})